import * as styles from './styles';
import { KeyPressDetails, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { ChangeEvent, FC } from 'react';

interface FocusableInputProps extends Partial<HTMLInputElement> {
  focusKey?: string;
  onEnterPress: (props: object, details: KeyPressDetails) => void;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const FocusableInput: FC<FocusableInputProps> = (props) => {
  const { focusKey, value, maxLength, placeholder, onEnterPress, onChange } = props;
  const onFocus = () => {
    ref.current.focus();
  };

  const onBlur = () => {
    ref.current.blur();
  };

  const { ref, focused } = useFocusable({
    focusKey,
    onEnterPress,
    onFocus,
    onBlur
  });

  return (
    <input
      css={[styles.focusableInput, focused && styles.focusedInput]}
      value={value}
      maxLength={maxLength}
      ref={ref}
      onChange={onChange}
      placeholder={placeholder}
    />
  );
};

export default FocusableInput;
